module.exports = __webpack_public_path__ + "static/media/FazzNeue-Bold.a239159a.ttf";